import { getResidenceInfo, getStreetInfo } from '@Shared/helpers/address';
import { AddressValue } from '@src/shared/types';

export interface AddressViewProps {
    variant?: 'compact' | 'extended';
    address: AddressValue;
}

const AddressView = ({ address, variant, ...other }: AddressViewProps) => {
    const firstLine = getResidenceInfo(address);
    const secondLine = getStreetInfo(address);

    const Info = () => {
        return (
            <div {...other}>
                <p>{firstLine}</p>
                <p>{secondLine}</p>
                {variant === 'extended' && (
                    <>
                        <p>{address.city}</p>
                        <p>{address.postcode}</p>
                    </>
                )}
            </div>
        );
    };

    return <Info />;
};

export default AddressView;
